import React from "react";

import { useParams, useNavigate } from "react-router-dom";
import styled from "@emotion/styled";

import BG_HELPER from "../../assets/images/bg-svg-helper.svg";

import MILK_HERO from "../../assets/images/rewards/Milk_hero.png";
import DRINK_HERO from "../../assets/images/rewards/drink_hero.png";
import MOVE_HERO from "../../assets/images/rewards/Move_hero.png";
import VEGGIE_HERO from "../../assets/images/rewards/Veggie_hero.png";
import Cow from "../../components/monkHelper/Cow";
import Vegetable from "../../components/monkHelper/Vegetable";
import Excercise from "../../components/monkHelper/Exercise";
import Sweet from "../../components/monkHelper/Sweet";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";

import useAuth from "../../utils/useAuth";
import OverWeight from "../../components/monkHelper/OverWeight";
import LessHeight from "../../components/monkHelper/LessHeight";
import LessWeight from "../../components/monkHelper/LessWeight";

const MonkHelper = () => {
  const { type } = useParams();
  const { isStudent } = useAuth();
  const navigate = useNavigate();
  let data = { img: null, content: null, headerText: "" };

  if (type === "milk") {
    data.content = <Cow />;
    data.headerText = "ดื่มดี นมวัว";
    data.img = MILK_HERO;
  } else if (type === "veggie") {
    data.headerText = "สุขชัวร์ เพิ่มผัก";
    data.content = <Vegetable />;
    data.img = VEGGIE_HERO;
  } else if (type === "move") {
    data.headerText = "รัก ออกกำลัง";
    data.content = <Excercise />;
    data.img = MOVE_HERO;
  } else if (type === "sweet") {
    data.headerText = "หยุดยั้ง น้ำหวาน";
    data.content = <Sweet />;
    data.img = DRINK_HERO;
  } else if (type === "overWeight") {
    data.headerText = "เมื่อน้ำหนักเกิน";
    data.content = <OverWeight />;
  } else if (type === "lessWeight") {
    data.headerText = "เมื่อน้ำหนักน้อย";
    data.content = <LessWeight />;
  } else if (type === "lessHeight") {
    data.headerText = "เมื่อความสูง ต่ำกว่าเกณฑ์";
    data.content = <LessHeight />;
  }

  return (
    <Background>
      <Container>
        <HeadC>
          <HeaderHint>ตัวช่วย</HeaderHint>
          <HeaderText>{data.headerText}</HeaderText>
          {data.img && <IMG_HERO src={data.img} />}
          <IMG src={BG_HELPER} />
        </HeadC>

        <ContentContainer>{data.content}</ContentContainer>
      </Container>
    </Background>
  );
};

const HeadC = styled.div`
  position: relative;
`;

const IMG = styled.img`
  width: 100%;
`;

const IMG_HERO = styled.img`
  position: absolute;
  right: 20%;
  //width: 17%;
  height: 90%;
  top: 20px;
  ${responsive.mobile(css`
    height: 100%;
    top: 0px;
  `)};
`;

const HeaderText = styled.span`
  position: absolute;
  font-style: normal;
  font-weight: 700;
  font-size: 38.4077px;
  line-height: 38px;
  /* identical to box height, or 100% */
  margin-left: 80px;
  top: 70%;

  /* Theme/Head */

  color: #047751;

  ${responsive.mobile(css`
    font-size: 26px;
    margin-left: 24px;
    top: 62%;
  `)};
`;

const HeaderHint = styled(HeaderText)`
  color: #ff6a40;
  top: 55%;
  ${responsive.mobile(css`
    top: 36%;
  `)};
`;

const Background = styled.div`
  background: #fffbeb;
  font-family: "Noto Sans Thai", "Noto Sans";
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  width: 1144px;
  background: #ffffff;
`;

const ContentContainer = styled.div`
  margin-top: 24px;
  margin-left: 116px;
  margin-right: 116px;
  margin-bottom: 24px;

  ${responsive.tablet(css`
    // margin-top: 24px;
    // max-width: 834px;
    // margin: auto;
    // margin-bottom: 24px;
    margin: 24px 24px 24px 24px;
  `)}

  ${responsive.mobile(css`
    margin-left: 8px;
    margin-right: 8px;
    margin-bottom: 24px;
  `)}
`;

const TextHint = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  /* or 144% */

  text-align: center;

  /* Neutral / 600 */

  color: #4b5768;
`;

const SendMsgButton = styled.button`
  align-items: center;
  padding: 14px 32px;

  /* Primary/Green 50 */

  background: #b5f6df;
  /* Primary/Green 400 */

  border: 1px solid #16af7b;
  border-radius: 100px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  /* identical to box height, or 144% */

  /* Primary/Green 400 */

  color: #16af7b;
  cursor: pointer;
`;

export default MonkHelper;
